import { render, staticRenderFns } from "./UploadApp.vue?vue&type=template&id=3309a1d1&scoped=true&"
import script from "./UploadApp.vue?vue&type=script&lang=js&"
export * from "./UploadApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3309a1d1",
  null
  
)

export default component.exports